import { Routes, Route } from "react-router-dom";
import { Promotion } from "./components/Promotion";
import { PromotionDetails } from "./components/PromotionDetails";

export default function PromotionRoutes() {
    return (
        <Routes>
            <Route index element={<Promotion />} />
            <Route path=":pageUrl" element={<PromotionDetails />} />
        </Routes>
    );
}
